export const isDeveloper = (state) => {
  if (state.user.isDeveloper || state.kioskUser.isDeveloper) {
    return true;
  }
  return false;
};
